import { IMAGE_MIME_TYPES } from 'pages/Batch/configs';

import type { IProcessResult } from './toolchain';

const createImage = (src: string): HTMLImageElement => {
  const image = new Image();
  image.crossOrigin = 'anonymous';
  image.src = src;
  return image;
};

function enhanceByIntensity(image: HTMLImageElement, enhanceMapping: Record<string, string>, intensity: number): Promise<IProcessResult> {
  const { height, width } = image;
  const canvas = document.createElement('canvas');
  canvas.height = height;
  canvas.width = width;
  const ctx = canvas.getContext('2d');

  const enhancedImg = createImage(enhanceMapping[image.src]);

  return new Promise(resolve => {
    enhancedImg.onload = () => {
      if (ctx) {
        const { height: enhanceHeight, width: enhanceWidth } = enhancedImg;
        canvas.height = enhanceHeight;
        canvas.width = enhanceWidth;
        ctx.drawImage(image, 0, 0, enhanceWidth, enhanceHeight);

        ctx.globalAlpha = intensity;
        ctx.drawImage(enhancedImg, 0, 0, enhanceWidth, enhanceHeight);

        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 1;

        return canvas.toBlob(blob => blob && resolve({ blob, result: URL.createObjectURL(blob) }), IMAGE_MIME_TYPES.WEBP);
      }
    };
  });
}

export default enhanceByIntensity;
